module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user5-73a211dd4641898c4754f3155ec3e228.jpg";